/* VÀLIEN — Künye ızgarası (rev.18)
   Ürün sayfasında "Nasıl Kullanılır" bölümünün hemen üstüne, INCI tablolarından
   doğrulanmış değerlerle bir künye ızgarası yerleştirir.
   Veri kaynağı: Drive > Formüller (INCI · 11 ürün), okuma 11.09.2026.
   İddia dili: yalnızca "…e varan" formatı, INCI adı, ambalaj bilgisi.

   13.09.2026 düzeltmesi (rev.20'ye alınırken): kolajen maskesinin handle'ı
   'yogun-onarici-kolajen-maske' yazıyordu — o handle canlıda YOK, ürün adı
   değişmişti. 'yogun-nemlendirici-kolajen-maske' ile değiştirildi; beş
   handle'ın hepsi canlı Shopify'dan tek tek doğrulandı. Düzeltilmeseydi künye
   o üründe hiç görünmeyecekti. Aynı hata cilt tipi testini de bozmuştu:
   docs/tema-cilt-testi-geri-alma.md */
(function () {
  var DATA = {
    'yaslanma-karsiti-krem-pdrn': {
      values: [
        { l: 'PDRN<br>(Sodium DNA)', v: '10.000', u: "ppm'e varan" },
        { l: 'Niasinamid', v: '%1', u: "'e varan" },
        { l: 'Hacim', v: '50', u: 'ml' },
        { l: 'Form', v: '', u: 'Krem' }
      ],
      ticks: ['Cica', 'Hyalüronik asit', 'Skualan', 'Panthenol']
    },
    'yaslanma-karsiti-serum': {
      values: [
        { l: 'PDRN<br>(Sodium DNA)', v: '5.000', u: "ppm'e varan" },
        { l: 'Niasinamid', v: '%5', u: "'e varan" },
        { l: 'Hyalüronik asit', v: '3', u: 'form' },
        { l: 'Hacim', v: '30', u: 'ml' }
      ],
      ticks: ['Adenozin', 'Hidrolize kolajen', 'Coptis Japonica']
    },
    'akne-toner-pad': {
      values: [
        { l: 'Niasinamid', v: '%5', u: "'e varan" },
        { l: 'BHA', v: 'Çift', u: 'salisilik + betain' },
        { l: 'Adet', v: '60', u: 'pad' },
        { l: 'Form', v: '', u: 'Toner pad' }
      ],
      ticks: ['Cica', 'Çinko PCA', 'Allantoin', 'Panthenol']
    },
    'gozenek-karsiti-ve-temizleyici-toner-pad': {
      values: [
        { l: 'Niasinamid', v: '%5', u: "'e varan" },
        { l: 'BHA', v: 'Çift', u: 'salisilik + betain' },
        { l: 'Adet', v: '60', u: 'pad' },
        { l: 'Form', v: '', u: 'Toner pad' }
      ],
      ticks: ['Cica', 'Çinko PCA', 'Laktik asit', 'Panthenol']
    },
    'yogun-nemlendirici-kolajen-maske': {
      values: [
        { l: 'Niasinamid', v: '%5', u: "'e varan" },
        { l: 'Hidrolize kolajen', v: '%5', u: "'e varan" },
        { l: 'Adet', v: '7', u: 'kapsül' },
        { l: 'Form', v: '', u: 'Kapsül maske' }
      ],
      ticks: ['Adenozin', 'Beta-glukan', 'Cica', 'Panthenol']
    }
  };

  var TICK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="4 13 9 18 20 6"/></svg>';

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function build() {
    if (document.querySelector('.vp-kunye')) return true;
    var handle = currentHandle();
    if (!handle) return true;
    var d = DATA[handle];
    if (!d) return true;

    var steps = document.querySelector('.valien-product .vp-steps');
    if (!steps) return false;

    var html = '<div class="vp-kunye__label">KÜNYE</div><div class="vp-kunye__box">';

    html += '<div class="vp-kunye__vals">';
    for (var i = 0; i < d.values.length; i++) {
      var c = d.values[i];
      html += '<div class="vp-kunye__cell">' +
        '<div class="vp-kunye__l">' + c.l + '</div>' +
        '<div class="vp-kunye__v">' +
        (c.v ? c.v + ' ' : '') +
        (c.u ? '<small>' + c.u + '</small>' : '') +
        '</div></div>';
    }
    html += '</div>';

    html += '<div class="vp-kunye__ticks">';
    for (var j = 0; j < d.ticks.length; j++) {
      html += '<div class="vp-kunye__cell">' +
        '<div class="vp-kunye__l">' + d.ticks[j] + '</div>' +
        '<div class="vp-kunye__v"><span class="vp-kunye__tick">' + TICK_SVG + '</span></div>' +
        '</div>';
    }
    html += '</div></div>';

    var wrap = document.createElement('div');
    wrap.className = 'vp-kunye';
    wrap.innerHTML = html;
    // "Nasıl Kullanılır?" başlığı adım kutusundan ayrı bir eleman —
    // künye o başlığın da önüne girmeli, arasına değil.
    var anchor = steps;
    var prev = steps.previousElementSibling;
    if (prev && /^H[1-6]$/.test(prev.tagName)) anchor = prev;

    anchor.parentNode.insertBefore(wrap, anchor);
    return true;
  }

  function run() {
    if (build()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (build() || tries > 12) clearInterval(t);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
